import { Card, Stack, Typography } from '@mui/material';
import { MobileFirstContainer } from '../../layouts/MobileFirstContainer';
import { HeaderBar, LanguageSelector } from './Header';
import { ErrorOutline } from '@mui/icons-material';

export default function SessionErrorScreen() {
  return (
    <MobileFirstContainer>
      <HeaderBar languageSelector={<LanguageSelector />} />
      <Stack padding={2} height='100%' boxSizing='border-box' gap={2}>
        <Card
          sx={{
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            padding: 2,
            borderRadius: '10px',
          }}
          elevation={4}
        >
          <Stack width='100%%' height='100%%' boxSizing='border-box' flexDirection='row' alignItems='center' gap='1rem'>
            <ErrorOutline fontSize='large' />
            <Stack gap='1em'>
              <Typography variant='h5' fontWeight='bold'>
                Es ist ein Fehler aufgetreten.
              </Typography>
              <Typography variant='h6'>Bitte kontaktieren Sie die den Support.</Typography>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    </MobileFirstContainer>
  );
}
